import { environment } from "@env/environment"
import * as moment from "moment"
import { ConfigDefinitions } from "./definitions/types"

export const getCheckedIds = (arr: any[]) => getIds(getChecked(arr))

export const getChecked = (arr: any[]) => arr.filter(({ checked }) => checked)

export const getIds = (arr: any[]) => arr.map(({ id }) => id)

export const byId = (id: number) => (it: any) => it.id == id
export const notId = (id: number) => (it: any) => it.id != id
export const arrRemoveId = (id: number) => (arr: any[]) => arr.filter(notId(id))

export const copy = (item: any) => ({ ...item })

export const to2Didigts = (num: number) => (num < 10 ? `0${num}` : num)

export const arrToCls = (arr: any[]) => arr.filter(Boolean).join(" ")

export const sumArr = (arr: any[]) => arr.reduce((acc, it) => acc + it, 0)

export const sumByProp = (arr: any[], propName: string) =>
	sumArr(arr.map((row) => Number(row[propName])))

export const uniqueArr = (arr: any[]) => [...new Set(arr)]

export const viewItemUrl = (id: number, type: string, isEn: boolean = false) =>
	`${environment.serverUrl}/item-view/${type}/${id}${isEn ? "?isEn=1" : ""}`

const dateSort = (it, it2) => new Date(it).getTime() - new Date(it2).getTime()
export const latest = (a: any, b: any) => dateSort(b.date, a.date)
export const oldest = (a: any, b: any) => dateSort(a.date, b.date)

export const dateDisplay = (date) =>
	moment.utc(date).format(ConfigDefinitions.momentDateDisplay)

export const stripTags = (str: string, toSpace: boolean = false) =>
	str.toString().replace(/<\/?[^>]+>/gi, toSpace ? " " : "")

export const flipYesNo = (value: string) => (value === "yes" ? "no" : "yes")

export function defaultEmptyString(value: any) {
	return value || ""
}
export function defaultZero(value: any) {
	return value || 0
}

export const tableNameDisplay = (tableName: string) => {
	switch (tableName) {
		case "mixed_list":
			return "followups"
		case "solo_time_allocations":
			return "time_allocations"
		case "expenses":
			return "insert_expenses"
	}
	return tableName
}
